
import { findCategoryByPath } from '@marketplace/helpers/category.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { mapGetters } from 'vuex'

const HOVER_DELAY = 100

export default {
    data() {
        return {
            categoryPath: null,
            timer: null,
        }
    },

    computed: {
        ...mapGetters('marketplace', ['categories', 'navigation']),
        ...mapGetters('global', ['preferredView']),

        activeCategory() {
            if (this.categoryPath) {
                return findCategoryByPath(this.categories, this.categoryPath)
            }

            return null
        },

        subCategories() {
            if (this.activeCategory?.path === 'food-and-beverages') {
                const bla = this.categories.find(
                    (item) => item.path === 'food-and-beverages'
                )

                return [
                    ...bla.children[0].children.slice(0, 12),
                    ...bla.children[1].children.slice(0, 6),
                ]
            }

            return this.activeCategory.children
        },

        selectedView() {
            if (!this.$helpers.isLoggedIn) {
                return 'marketplace'
            }

            if (this.preferredView) {
                return this.preferredView
            }

            if (this.$breakpoint.includes('touch')) {
                return 'wall'
            }

            return 'listings'
        },

        categorizedCategories() {
            const children = this.subCategories

            return [
                children.slice(0, 6),
                children.slice(6, 12),
                children.slice(12),
            ]
        },
    },

    methods: {
        onMouseEnter(categoryPath) {
            this.clearTimer()

            this.timer = setTimeout(() => {
                this.categoryPath = categoryPath
            }, HOVER_DELAY)
        },

        onMouseLeave() {
            this.clearTimer()

            this.timer = setTimeout(() => {
                this.categoryPath = null
            }, HOVER_DELAY)
        },

        onSubMenuEnter() {
            this.clearTimer()
        },

        closeMenu() {
            this.timer = setTimeout(() => {
                this.categoryPath = null
            }, HOVER_DELAY)
        },

        clearTimer() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
        },

        getUrl(url) {
            return decodeURIComponent(this.localePath(url))
        },

        trackMainCategoryClick(category) {
            trackClick('Header Category - Main', {
                category: 'Header',
                mainCategory: category.slug,
            })
        },

        trackSubCategoryClick(category) {
            trackClick('Header Category - Sub', {
                category: 'Header',
                subCategory: category.name,
            })
        },

        trackSimpleLinkClick(title, category, name) {
            trackClick(title, {
                category,
                mainCategory: this.categoryPath,
                name,
            })
        },

        trackTopBrandClick(brand) {
            trackClick('Header Category - Top Brand', {
                category: 'Header',
                mainCategory: this.categoryPath,
                brand: brand.name,
            })
        },
    },
}
